<template>
  <div class="cloud-desktop-file-submit">
    <div class="content-wrap">
      <img class="upload-icon" src="./assets/upload.svg" alt="" />
      <div v-if="!isDone || isLoading" class="text-wrap items-center muti-line-omit">
        <div class="text-content overflow-hidden">
          <span>{{ isLoading ? '正在为你提交项目文件…' : '完成实操后提交项目文件' }}</span>
        </div>
      </div>
      <div
        v-else
        class="text-wrap flex-col justify-center"
        :class="{ 'muti-line-omit': !uploadTime }"
      >
        <div v-if="isUploadSuccess" class="text-content">
          <span>已成功提交项目文件</span><img src="./assets/success.svg" alt="" />
        </div>
        <div v-else class="text-content">
          <span>提交项目文件失败</span><img src="./assets/error.svg" alt="" />
        </div>
        <div v-if="uploadTime" class="upload-time">最近提交成功 {{ uploadTime }}</div>
      </div>
    </div>
    <div class="btn-wrap">
      <div
        v-if="!isLoading"
        class="submit-btn"
        :class="{ 'sbumit-btn-undo': !uploadTime }"
        @click="handleSubmitClick"
      >
        {{ isDone ? '重新提交' : '提交文件' }}
      </div>
      <div v-else class="loading">
        <img class="loading-icon" src="./assets/loading.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Environment } from '@/store/modules/common/types/index';
import { namespace } from 'vuex-class';
import CLOUD_DESKTOP_ID from '../PracticeCourt/graphql/cloudDesktopId';
import SUBMIT_DESKTOP_FILE from './graphql/submitDesktopFile';
import { ApolloError } from '@forchange/cleman-client';
import dayjs from 'dayjs';

const userModule = namespace('common');

enum CURRENTSTATUS {
  UNDO = 'UNDO',
  LOADING = 'LOADING',
  DONE = 'DONE'
}

@Component({})
export default class Index extends Vue {
  @Prop({ type: Object }) content!: Content & {
    desktopId: string;
    filePath: string;
    finishedAt: string;
    isSuccess: boolean;
  };
  @userModule.State('environment') environment!: Environment;

  currentStatus: CURRENTSTATUS = CURRENTSTATUS.UNDO;
  isUploadSuccess = false;

  get courseId() {
    const courseId =
      this.environment && this.environment.kind === 'public-preview'
        ? this.environment.sharedKey
        : '';
    return courseId;
  }

  get isLoading() {
    return this.currentStatus === CURRENTSTATUS.LOADING;
  }

  get isUndo() {
    return this.currentStatus === CURRENTSTATUS.UNDO;
  }

  get isDone() {
    return this.uploadTime || this.currentStatus === CURRENTSTATUS.DONE;
  }

  get uploadTime() {
    return this.content?.finishedAt;
  }
  // 提交考试文件
  async desktopUploadFile() {
    const { courseId } = this;
    const { filePath, desktopId, $id, $kind } = this.content;
    this.currentStatus = CURRENTSTATUS.LOADING;

    try {
      const res = await window.$getClemanClient().apollo.mutate({
        mutation: CLOUD_DESKTOP_ID,
        variables: {
          desktopId,
          courseId
        }
      });
      const status = res.data.retrieveDesktopInstance.status;
      let time = '';
      if (status === 'RUNNING' || status === 'USING') {
        const instanceId = res.data.retrieveDesktopInstance.id;
        const submitData = await window.$getClemanClient().apollo.mutate({
          mutation: SUBMIT_DESKTOP_FILE,
          variables: {
            fileName: filePath,
            instanceId,
            courseId
          }
        });

        if (submitData.data.desktopCourseUploadFile.updatedAt) {
          this.$Message.success({
            time: 1500,
            content: `文件${filePath} 已提交`
          });
          time = dayjs(submitData.data.desktopCourseUploadFile.updatedA).format('MM/DD HH:mm');
        }
        this.isUploadSuccess = true;
      } else {
        this.$Message.warn({
          time: 1500,
          content: '云桌面尚未就绪，请稍后再试'
        });
        this.isUploadSuccess = false;
      }
      window.storyteller.updateAssignContent({
        $id,
        $kind,
        ...{
          finishedAt: time,
          isSuccess: this.isUploadSuccess
        }
      });
      this.currentStatus = CURRENTSTATUS.DONE;
    } catch (e) {
      if (e instanceof ApolloError) {
        this.$Message.error({
          time: 1500,
          content: e.graphQLErrors[0].message
        });
      }
      this.isUploadSuccess = false;
      window.storyteller.updateAssignContent({
        $id,
        $kind,
        ...{
          isSuccess: this.isUploadSuccess
        }
      });
      this.currentStatus = CURRENTSTATUS.DONE;
    }
  }

  handleSubmitClick() {
    this.desktopUploadFile();
  }

  mounted() {
    if (typeof this.content.isSuccess === 'boolean') {
      this.isUploadSuccess = this.content.isSuccess;
      this.currentStatus = CURRENTSTATUS.DONE;
    }
  }
}
</script>

<style lang="scss" scoped>
.cloud-desktop-file-submit {
  @apply relative flex items-center justify-between  sm:w-4/5 md:w-112 mt-10 ml-10;
  height: 64px;
  padding: 0 16px 0 8px;
  color: #58517d;
  font-size: 16px;
  line-height: 22px;
  background: #f0f1f6;
  border-radius: 8px;

  .content-wrap {
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
  }
  .upload-icon {
    width: 40px;
    height: 40px;
    margin-right: 8px;
  }
  .text-wrap {
    display: flex;
    height: 100%;
    padding-right: 4px;
    overflow: hidden;
  }
  .text-content {
    display: flex;

    img {
      margin-left: 4px;
    }
    span {
      min-width: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .muti-line-omit {
    span {
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      white-space: break-spaces;
    }
  }
  .upload-time {
    margin-top: 4px;
    overflow: hidden;
    color: rgba(88, 81, 125, 0.6);
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .upload-time {
    margin-top: 4px;
    overflow: hidden;
    color: rgba(88, 81, 125, 0.6);
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .btn-wrap {
    flex-shrink: 0;
    .submit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 88px;
      height: 32px;
      color: #433eff;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #433eff;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    .sbumit-btn-undo {
      color: #fff;
      background: linear-gradient(270deg, #8b8eff 0%, #524eff 100%);
      border: none;
    }
  }

  .loading-icon {
    transform: rotate(0);
    -webkit-animation: loadingRotate 1s infinite cubic-bezier(0.39, 0.14, 0.53, 0.74);
    animation: loadingRotate 1s infinite cubic-bezier(0.39, 0.14, 0.53, 0.74);
  }
  @keyframes loadingRotate {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
